import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getUserApiUrl } from './user.paths';
import {
  UserPreferenceType,
  UserProfileType,
  UserSettingsType,
  User,
  ChangeEmailType,
  VerifyEmailType,
} from './user.types';

const getProfile = async () => {
  const res = await http.get<ApiResponseBody<UserProfileType>>(getUserApiUrl.profile, { withCredentials: true });
  return res.data.data;
};

const getUserSettings = async (id: string) => {
  const res = await http.get<ApiResponseBody<UserSettingsType>>(getUserApiUrl.settingsById(id));
  return res.data.data;
};

const createUserSettings = async ({ userId, ...data }: Partial<UserSettingsType> & { userId: string }) => {
  const res = await http.post<ApiResponseBody<UserSettingsType>>(getUserApiUrl.settingsById(userId), data);
  return res.data.data;
};

const updateUserSettings = async ({ userId, ...data }: Partial<UserSettingsType> & { userId: string }) => {
  const res = await http.patch<ApiResponseBody<UserSettingsType>>(getUserApiUrl.settingsById(userId), data);
  return res.data.data;
};

const resendUserInvite = async (userId: string) => {
  const res = await http.post<ApiResponseBody<string>>(getUserApiUrl.resendInvite(userId));
  return res.data.data;
};

const updateUserPreferences = async ({ userPreferences }: { userPreferences: UserPreferenceType[] }) => {
  const res = await http.patch<ApiResponseBody<User>>(getUserApiUrl.preferences, { userPreferences });
  return res.data.data;
};

const changeEmail = async ({ userId, ...data }: Partial<ChangeEmailType> & { userId: string }) => {
  const res = await http.post<ApiResponseBody<ChangeEmailType>>(getUserApiUrl.changeEmail(userId), data);
  return res.data.data;
};

const verifyEmail = async ({ userId, ...data }: Partial<VerifyEmailType> & { userId: string }) => {
  const res = await http.post<ApiResponseBody<VerifyEmailType>>(getUserApiUrl.verifyEmail(userId), data);
  return res.data.data;
};

export const userApiFetcher = {
  updateUserPreferences,
  getProfile,
  getUserSettings,
  createUserSettings,
  updateUserSettings,
  resendUserInvite,
  changeEmail,
  verifyEmail,
};
